export default "/images/vendor/flag-icon-css/flags/4x3/bi.svg?be5f159137e399dca23b2a5c0e420066";